import { ApiResponse, DataWithPagination } from '@/shared/types';
import {
  BusinessAreaEmployee,
  CompanyEmployee,
  CurrentUser,
  TaskUser,
  UserBaseInfo,
  UserDetails,
  UserItem,
} from '../domain';
import { Role } from '../domain/role';
import { UserRateModel } from '../domain/user-rate-model';
import {
  ChangePasswordJson,
  CreateUserJson,
  EditUserJson,
  EditUserRoleJson,
  HourlyRateJson,
  LastHourlyRateJson,
  OrganizationEmployeeJson,
} from '../types';

export abstract class UserRepository {
  abstract getAllUsers(
    pageNumber?: number,
    filter?: string,
  ): Promise<DataWithPagination<UserItem[]>>;
  abstract getAllUsersBaseInfo(query: {
    searchTerm?: string;
    businessAreaId?: number;
  }): Promise<Array<UserBaseInfo>>;
  abstract getUserDetails(userId: number): Promise<UserDetails>;
  abstract enableUser(id: number): Promise<ApiResponse<unknown>>;
  abstract disableUser(id: number): Promise<ApiResponse<unknown>>;
  abstract addAccess(id: number): Promise<ApiResponse<unknown>>;
  abstract removeAccess(id: number): Promise<ApiResponse<unknown>>;
  abstract createUser(
    userJson: CreateUserJson,
  ): Promise<ApiResponse<{ userId: number }>>;
  abstract getUserRoles(): Promise<Role[]>;
  abstract getUsersByBusinessArea(
    businessAreaId: number,
    pageNumber?: number,
    filter?: string,
  ): Promise<DataWithPagination<BusinessAreaEmployee[]>>;
  abstract getEmployeesByCompany(
    companyId: number,
    pageNumber?: number,
    filter?: string,
  ): Promise<DataWithPagination<CompanyEmployee[]>>;
  abstract getEmployeesByOrganization(
    organizationId: number,
    pageNumber?: number,
    filter?: string,
  ): Promise<DataWithPagination<OrganizationEmployeeJson[]>>;
  abstract getUsersByTask(
    taskId: number,
    pageNumber?: number,
    filter?: string,
  ): Promise<DataWithPagination<TaskUser[]>>;
  abstract updateUser(userJson: EditUserJson): Promise<ApiResponse<unknown>>;
  abstract updateRole(
    userJson: EditUserRoleJson,
  ): Promise<ApiResponse<unknown>>;
  abstract getCurrentUser(
    token: string,
    tenantId: number,
  ): Promise<CurrentUser>;
  abstract csvUserImport(data: FormData): Promise<void>;
  abstract getUserRate(
    userId: number,
  ): Promise<DataWithPagination<UserRateModel[]>>;
  abstract createUserRate(
    userJson: HourlyRateJson,
  ): Promise<ApiResponse<{ data: { userId: number } }>>;
  abstract updateUserRate(
    userJson: HourlyRateJson,
  ): Promise<ApiResponse<unknown>>;
  abstract changePassword(
    changePasswordJson: ChangePasswordJson,
  ): Promise<ApiResponse<unknown>>;
  abstract deleteUser(Id: number): Promise<ApiResponse<unknown>>;
  abstract updateLastAccess(): Promise<void>;
  abstract updateLastHourlyRate(
    lastActiveHourlyRate: LastHourlyRateJson,
  ): Promise<ApiResponse<unknown>>;
}
